import React from "react";

const shimmer =
  "animate-pulse bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%]";

const PolygonsShimer = () => {
  return (
    <div className="h-auto w-full flex">
      {/* Sidebars */}

      <div className="w-[100%] h-auto flex flex-col gap-3 items-center justify-start">
        {/* Main 500x500 shimmer box */}
        {/* Absolute shimmer bar at bottom */}
        <div className={`${shimmer}  w-[100%] h-[80px] rounded-md shadow-sm`} />
        <div className={`${shimmer}  w-[100%] h-[80px] rounded-md shadow-sm`} />
        <div className={`${shimmer}  w-[100%] h-[80px] rounded-md shadow-sm`} />
        <div className={`${shimmer}  w-[100%] h-[80px] rounded-md shadow-sm`} />
        <div className={`${shimmer}  w-[100%] h-[80px] rounded-md shadow-sm`} />
        <div className={`${shimmer}  w-[100%] h-[80px] rounded-md shadow-sm`} />
      </div>
    </div>
  );
};

export default PolygonsShimer;
